import React from 'react'
import { useTranslation } from 'react-i18next'
import {Descriptions, Tooltip, Typography} from 'antd'
import classNames from 'classnames'

import {useScreenType} from '@/hooks'

import {AssociatedOutletsProps} from './props'
import styles from './AssociatedOutlets.scss'
import { OUTLET_VALUE } from '@/constants/playwright-ids'

export const AssociatedOutlets: React.FC<AssociatedOutletsProps> = ({outlets, title}) => {
    const { t } = useTranslation()
    const {isMobile} = useScreenType()
    const hasOutlets = outlets.length > 0
    const formattedOutlets = hasOutlets ? outlets.map((outlet) => outlet.trim()).join(', ') : ''

    return (
        <Descriptions
            className={classNames(styles.descriptionLabel, {
                [styles.descriptionLabelMobile]: isMobile
            })}
            title=''
            layout={isMobile ? 'vertical' : 'horizontal'}
            column={1}
            colon={false}
        >
            <Descriptions.Item label={title || t('ChangeBankAccountDetails.labels.associatedOutlets')}>
                {hasOutlets ? (
                    <Typography.Text>{formattedOutlets}</Typography.Text>
                ) : (
                    <Typography.Text type='secondary'>
                        {t('ChangeBankAccountDetails.labels.noAssociatedSettlementsOutlets')}
                    </Typography.Text>
                )}
            </Descriptions.Item>
        </Descriptions>
    )
}
